import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import "./ForAccountingCompanies.css";
import CMSTranslationFile from "../ForAccountingCompanies/ForAccountingCompanies_Translation_CorpTranslation.json";
import Image from "../../Assests/for-accounting-companies.webp";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage;

class ForAccountingCompanies extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }
  callback = () => {
    this.setState({
      reRender: true
    });
  };
  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar callBack={this.callback} />
        <div className="ID_ForAccountingCompanies">
          <br></br>
          <br></br>
          <div
            style={{
              // fontWeight: 500,
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            <strong>
              {" "}
              {
                CMSTranslationFile.ForAccountingCompanies_Title[
                  userSelectedLanguage
                ]
              }
            </strong>
            {/* For Accounting Companies */}
          </div>
          <br></br>
          <section
            style={{
              // fontSize: "20px",
              textAlign: "left"
            }}
          >
            {
              CMSTranslationFile.ForAccountingCompanies_Text1[
                userSelectedLanguage
              ]
            }
            <a
              href={
                "mailto:" +
                "" +
                CMSTranslationFile.ForAccountingCompanies_Link[
                  userSelectedLanguage
                ].replace(/[()]/g, "")
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {
                CMSTranslationFile.ForAccountingCompanies_Link[
                  userSelectedLanguage
                ]
              }
            </a>

            {
              CMSTranslationFile.ForAccountingCompanies_Text2[
                userSelectedLanguage
              ]
            }
          </section>
          <br></br>

          <img src={Image} className="forAccountingCompaniesImage" />
        </div>
        <ScrolltoTop />
        <Footer isCorpPortal={true} />
      </div>
    );
  }
}
export default ForAccountingCompanies;
